import { Camera } from "lucide-react";

export default function SlabComingSoon({ className = "" }) {
  return (
    <div className={`[perspective:1300px] ${className}`} data-testid="slab-coming-soon">
      <div className="relative mx-auto w-full max-w-[380px] rounded-[26px] bg-gradient-to-b from-white via-[#f2f3f5] to-[#e2e6ea] p-3 shadow-[0_30px_60px_-22px_rgba(0,0,0,0.35)]">
        <div className="pointer-events-none absolute inset-0 rounded-[26px] ring-1 ring-white/70" />
        <div className="relative rounded-2xl border border-dashed border-neutral-300 bg-[#FAFAFA] min-h-[420px] flex flex-col items-center justify-center text-center px-8">
          <div className="w-14 h-14 rounded-2xl bg-[#0A0A0A] text-white flex items-center justify-center mb-5">
            <Camera size={22} />
          </div>
          <div className="font-display text-xl tracking-tight text-[#0A0A0A]" style={{ fontWeight: 900 }}>Image Coming Soon</div>
          <p className="text-neutral-400 text-sm mt-2 max-w-[240px]">A photo of this certified slab will be added shortly.</p>
          <div className="mt-6 text-[10px] tracking-[0.4em] uppercase text-neutral-300">MAS Grading</div>
        </div>
      </div>
    </div>
  );
}
